export const docApprovalFunction = {}

docApprovalFunction.nextStage = (obj) => {
  if (sessionStorage.getItem('token')) {
    //Configuración
    let config = {
      pathname: `/${obj.nextComponent}`,
      //pathname: `/DynamicFormComponent`,
      state: {
        stageName: obj.stageName,
        stageId: obj.stageId,
        stage: obj.stage,
        folioId: obj.folioId,
        actorId: obj.actorId,
      }
    }
    //Objeto lleno
    obj.navigate(config)
  }
  else {
    alert("No se encontró usuario.")
  }
}